<div *ngIf="community" class="container-fluid py-4">
  <app-header-title
    [dataTestId]="'manage-community-title'"
    [titleHint]="'MANAGE_COMMUNITY_TITLE'"
    [link]="LINK_COMMUNITY_VIEW"
    [itemId]="community.entity_id"
    [title]="community.title"
  ></app-header-title>
  <ul ngbNav #nav="ngbNav" (navChange)="onTabClick($event)" class="nav-tabs">
    <li ngbNavItem="update_data">
      <a ngbNavLink [attr.data-test-id]="'update_data'">
        {{ 'COMMUNITY_TAB_INFO' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-update-community
          [community]="community"
          [formContent]="formContent$ | async"
          [focusState]="focusState$ | async"
          (removeCommunity)="removeCommunity()"
          (updateCommunity)="updateCommunity($event)"
          (dirtyForm)="setFormStatus($event)"
          (formValueCanged)="onFormValueChanged($event)"
          (canceled)="onCancel()"
        ></app-update-community>
      </ng-template>
    </li>

    <ng-container *ngIf="community.permissions.view_join_requests">
      <li ngbNavItem="user_requests">
        <a ngbNavLink [attr.data-test-id]="'user_requests'">
          {{ 'COMMUNITY_USERS_REQUESTS_HINT' | translate }} ({{ receivedCounter }})
        </a>
        <ng-template ngbNavContent>
          <app-spinner>
            <app-grid-users-list
              [currentPage]="resolver.state.pagination?.currentPage"
              [pageSize]="pageSize"
              [totalCount]="resolver.state.pagination?.totalItemsCount"
              (pageChange)="resolver.onPageChanged($event)"
              [pagination]="true"
              [constructorData]="tableData$ | async"
              [noUsersHint]="'NO_COMMUNITY_USER_REQUESTS_TEXT'"
              [sortOptions]="SORT_OPTIONS"
              [currentSortCategory]="currentSortCategory"
              [ascending]="ascending"
              (action)="onTableAction($event)"
              (toggleSorting)="onSortParamChanged($event)"
              (toggleSortingByType)="toggleSortingOrderByType($event)"
            ></app-grid-users-list>
          </app-spinner>
        </ng-template>
      </li>
    </ng-container>

    <ng-container *ngIf="community.permissions.view_invitations">
      <li ngbNavItem="sent_invitations">
        <a ngbNavLink [attr.data-test-id]="'sent_invitations'">
          {{ 'COMMUNITY_SENT_INVITATIONS_HINT' | translate }} ({{ sentCounter }})
        </a>
        <ng-template ngbNavContent>
          <app-spinner>
            <app-grid-users-list
              [currentPage]="resolver.state.pagination?.currentPage"
              [pageSize]="pageSize"
              [totalCount]="resolver.state.pagination?.totalItemsCount"
              (pageChange)="resolver.onPageChanged($event)"
              [pagination]="true"
              [constructorData]="tableData$ | async"
              [noUsersHint]="'NO_COMMUNITY_INVITES_TEXT'"
              [sortOptions]="SORT_OPTIONS"
              [currentSortCategory]="currentSortCategory"
              [ascending]="ascending"
              (action)="onTableAction($event)"
              (toggleSorting)="onSortParamChanged($event)"
              (toggleSortingByType)="toggleSortingOrderByType($event)"
            ></app-grid-users-list>
          </app-spinner>
        </ng-template>
      </li>
    </ng-container>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
